import { FC } from 'react';
import { Link } from 'react-router-dom';

import boxImg from 'assets/brand/box.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import DecorativeImage from 'components/DecorativeImage';
import HelpSection from 'components/HelpSection';

import Card from '../components/Card';
import Title from '../components/Title';
import locales from './locales';

const ClosureCancelationConfirmation: FC = () => {
  return (
    <>
      <Card>
        <DecorativeImage src={boxImg} />
        <Title>{locales.title}</Title>
        <Text size="sm">{locales.body}</Text>
      </Card>
      <HelpSection>
        {locales.help}
        <Button as={Link} to="/cards" variant="inline-primary">
          {locales.clickHere}
        </Button>
        .
      </HelpSection>
    </>
  );
};

export default ClosureCancelationConfirmation;
